import { useIntl, type UserAmlQuestionnaireProfession } from '@capsicum/common';
import { useSetAtom } from 'jotai';
import { useEffect, useMemo, useState } from 'react';

import { amlQuestionnaireReducerAtom } from '../../data-access';
import { type AmlQuestionnaireProfessionOption } from '../../models';

const PROFESSIONS: Array<UserAmlQuestionnaireProfession> = [
	'architecture_engineering',
	'arts_culture_entertainment',
	'business_management_administration',
	'communications',
	'community_social_services',
	'education',
	'science_technology',
	'installation_repair_maintenance',
	'farming_fishing_forestry',
	'elected_government_official',
	'health_medicine',
	'law_public_policy',
	'marketing_sales',
	'trading',
	'blockchain_applications',
	'business_owner',
	'retired',
	'student',
	'unemployed',
	'other'
];

export const useAmlProfession = () => {
	const { $t } = useIntl();

	const [selectedItem, setSelectedItem] = useState<AmlQuestionnaireProfessionOption>();
	const [professionOther, setProfessionOther] = useState<string>();
	const dispatch = useSetAtom(amlQuestionnaireReducerAtom);

	useEffect(() => {
		if (!selectedItem) return;

		dispatch({ data: { profession: selectedItem.value, professionOther }, type: 'UPDATE_FORM_DATA' });

		const isValid = selectedItem.value !== 'other' || Boolean(professionOther);

		dispatch({ isValid, stepId: 'Profession', type: 'UPDATE_STEP_VALIDITY' });
	}, [selectedItem, professionOther]);

	const list = useMemo<Array<AmlQuestionnaireProfessionOption>>(
		() =>
			PROFESSIONS.map(profession => ({
				name: $t(`amlQuestionnaire.secondStep.professions.${profession}`),
				value: profession
			})),
		[]
	);

	const onSelect = (item: AmlQuestionnaireProfessionOption) => {
		setSelectedItem(item);
		if (item.value !== 'other') setProfessionOther('');
	};

	const onSearch = (data: Array<AmlQuestionnaireProfessionOption>, text: string) =>
		data.filter(item => item.name.includes(text) || item.value.includes(text));

	const handleInput = (input: string) => setProfessionOther(input);

	const isOtherSelected = selectedItem?.value === 'other';

	return { handleInput, isOtherSelected, list, onSearch, onSelect, selectedItem };
};
